import jsesc from "jsesc"

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)

  return result
}

const updateItem = (list, id, updates = {}) => {
  let result = Array.from(list)

  return result.map((item) => {
    if (item.id === id) {
      return {
        ...item,
        ...updates,
        id,
      }
    }

    return item
  })
}

const updateAllItems = (list, updates = {}) => {
  let result = Array.from(list)

  return result.map((item) => ({
    ...item,
    ...updates,
    id: item.id,
  }))
}

const deleteItem = (list, id) => {
  let result = Array.from(list)
  let index = result.findIndex((item) => item.id === id)
  result.splice(index, 1)

  return result
}

const escapeString = (string) => {
  return jsesc(string, { quotes: "double" })
}

const unescapeString = (string) => {
  try {
    let cleaned = string.replace(/\\x([0-9a-fA-F]{2})/g, "\\u00$1")
    let jsonStr = `{"result": "${cleaned}"}`
    let { result } = JSON.parse(jsonStr)
    return result
  } catch (err) {
    return ""
  }
}

export {
  reorder,
  updateItem,
  deleteItem,
  updateAllItems,
  escapeString,
  unescapeString,
}
